import { useKContext } from "@context"
import {
  getAndSaveAppAccessTokens,
  getToken,
  removeAppAccessTokens
} from "@utils/storage"
import { calculateTokenRefreshDelay } from "@utils/token"
import { useEffect } from "react"

export const useInitialRefreshToken = () => {
  const {
    isUserPath,
    setShowErrorResult,
    handleUserUnauthorized,
    setIsInitialized
  } = useKContext()

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const handleRefreshToken = async () => {
      try {
        await getAndSaveAppAccessTokens()
        scheduleTokenRefresh()
      } catch (err: any) {
        removeAppAccessTokens()
        setShowErrorResult(401)
      } finally {
        setIsInitialized(true)
      }
    }

    const scheduleTokenRefresh = async () => {
      const tokenWebApp = getToken("WebApp")
      if (!tokenWebApp) {
        handleUserUnauthorized()
        return
      }

      const diffInMilliseconds = calculateTokenRefreshDelay()

      if (diffInMilliseconds <= 0) {
        handleRefreshToken()
      } else {
        timeoutId = setTimeout(() => {
          handleRefreshToken()
        }, diffInMilliseconds)
        setIsInitialized(true)
      }
    }

    if (isUserPath) {
      scheduleTokenRefresh()
    } else {
      setIsInitialized(true)
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [isUserPath])
}
